(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var footer = document.querySelector('.wf-footer-{{ section.id }}');
  if (!footer) return;

  var MOBILE_BP = 749;
  var allDetails = footer.querySelectorAll('.wf-acc');

  function syncAccordions() {
    var isMobile = window.innerWidth <= MOBILE_BP;
    allDetails.forEach(function(el, i) {
      if (isMobile) {
        if (i === 0) {
          el.setAttribute('open', '');
        } else {
          el.removeAttribute('open');
        }
      } else {
        el.setAttribute('open', '');
      }
    });
  }

  syncAccordions();

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAccordions, 80);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  const menuBtn = document.querySelector('.fw-mobile-menu-btn');
  const searchBtn = document.querySelector('.fw-mobile-search-btn');

  const menu = document.getElementById('fw-mobile-menu');
  const overlay = document.querySelector('.fw-mobile-overlay');

  const searchPanel = document.getElementById('fw-mobile-search');
  const searchClose = searchPanel ? searchPanel.querySelector('.fw-mobile-search__close') : null;
  const searchInput = searchPanel ? searchPanel.querySelector('input[type="search"]') : null;

  const menuClose = menu ? menu.querySelector('.fw-mobile-menu__close') : null;

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  function closeMenu() {
    if (!menu || !overlay) return;
    menu.classList.remove('is-open');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    overlay.hidden = true;
    lockScroll(false);
    window.setTimeout(() => { menu.hidden = true; }, 250);
  }

  function openMenu() {
    if (!menu || !overlay) return;
    if (searchPanel && !searchPanel.hidden) closeSearch();

    menu.hidden = false;
    overlay.hidden = false;
    menu.classList.add('is-open');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
    lockScroll(true);
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    searchBtn && searchBtn.setAttribute('aria-expanded', 'false');
  }

  function openSearch() {
    if (!searchPanel) return;
    if (menu && !menu.hidden) closeMenu();

    searchPanel.hidden = false;
    searchBtn && searchBtn.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => { searchInput && searchInput.focus(); }, 0);
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      if (menu && menu.hidden) openMenu();
      else closeMenu();
    });
  }

  if (menuClose) menuClose.addEventListener('click', closeMenu);

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      if (searchPanel && searchPanel.hidden) openSearch();
      else closeSearch();
    });
  }

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (menu && !menu.hidden) closeMenu();
      if (searchPanel && !searchPanel.hidden) closeSearch();
    }
  });

  // open cart drawer from header cart icon
  document.addEventListener('click', function (e) {
    const cartTrigger = e.target.closest('.js-open-cart-drawer');
    if (!cartTrigger) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    e.preventDefault();

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open(cartTrigger);
      return;
    }

    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    const inner = cartDrawer.querySelector('.drawer__inner');

    cartDrawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    if (inner) inner.classList.add('active');

    document.body.classList.add('overflow-hidden');
  });
})();
  document.querySelectorAll('.fw-mobile-menu__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const item = toggle.closest('.fw-mobile-menu__item');
      const submenu = item ? item.querySelector('.fw-mobile-submenu') : null;
      const isOpen = item && item.classList.contains('is-open');

      document.querySelectorAll('.fw-mobile-menu__item.has-submenu').forEach(function(otherItem) {
        otherItem.classList.remove('is-open');
        const otherToggle = otherItem.querySelector('.fw-mobile-menu__toggle');
        const otherSubmenu = otherItem.querySelector('.fw-mobile-submenu');

        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        if (otherSubmenu) otherSubmenu.hidden = true;
      });

      if (!item || !submenu) return;

      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        submenu.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function swapHeroImages() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('#Banner-{{ section.id }} .wb-hero-img[data-mobile][data-desktop]').forEach(img => {
      const target = isMobile ? img.dataset.mobile : img.dataset.desktop;
      if (img.getAttribute('src') !== target) img.setAttribute('src', target);
    });
  }

  swapHeroImages();
  window.addEventListener('resize', swapHeroImages, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
